import { Icon, MenuItem, Text, type Color } from "@salestrak/ui";

/** One string carries the clock's state — on the Next row while the section
 *  is open, on the header while it is folded, never both — and at most one
 *  color: yellow for Update soon, red for Stale, none while healthy. */
export type FollowUpClockReading = { label: string; color?: Color };

/** The folded section's one fact, at the header's trailing edge: the same
 *  string the Next row reads when open, in the same color. */
export function FollowUpCaption({ reading }: { reading: FollowUpClockReading }) {
  return (
    <Text
      size="sm"
      variant={reading.color ? undefined : "muted"}
      color={reading.color}
      truncate={1}
    >
      {reading.label}
    </Text>
  );
}

/** The section menu's lifecycle row. Ending is rare and deliberate, so it
 *  lives behind the "…" rather than standing in the body beside the facts.
 *  A viewer who may not end it still sees the row, disabled with the reason
 *  — the capability is stated, never hidden. */
export function FollowUpEndMenuItem({
  onEnd,
  disabledReason,
}: {
  onEnd: () => void;
  disabledReason?: string;
}) {
  return (
    <MenuItem
      onClick={onEnd}
      {...(disabledReason ? { disabled: true, disabledReason } : {})}
    >
      <Icon name="x-circle" size="sm" />
      End Follow up
    </MenuItem>
  );
}
